module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/LU-20bb4d5801458368458dac22905deeba.png";